import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0315 from "../../course-03/lesson-15/lesson";
import lesson0316 from "../../course-03/lesson-16/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "36525cc2-814b-4dda-b159-6d254602de58",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0315),
    lesson: lesson0315,
  },
  {
    id: "787133f0-7184-4d2a-a892-fbbfcee57f3e",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0316),
    lesson: lesson0316,
  },
];

export default lessonLinks;
